import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

export const VIDEO_CONTROLS_STANDARD = "standard";
export const VIDEO_CONTROLS_MINIMAL = "minimal";

export default class VideoControlsStyle extends BaseOption {
  static userInterfaceComponent = {
    label: "Video Controls",
    component: inspectorTools.RADIO_BAR,
    props: {
      options: [
        {
          label: "Full",
          tooltip: "Long form: play bar, time, settings and full screen",
          value: VIDEO_CONTROLS_STANDARD,
        },
        {
          label: "Minimal",
          tooltip: "Short form: tap to play or pause, with a sound button in the corner",
          value: VIDEO_CONTROLS_MINIMAL,
        },
      ],
    },
  };

  static defaultValue = VIDEO_CONTROLS_STANDARD;

  static convertConfigValueToCompiledValue(configValue) {
    return configValue === VIDEO_CONTROLS_MINIMAL ? VIDEO_CONTROLS_MINIMAL : VIDEO_CONTROLS_STANDARD;
  }
}
